import React from 'react';
import Login from '@features/auth/components/login/Login';

const LoginPage: React.FC = () => {
  return <Login />;
};

export default LoginPage;